export default "__VITE_ASSET__D8FQv4zf__"